module.exports = __webpack_public_path__ + "files/eea6c65d8242d7c42e1198330b9c6138.png";